<template>
    <div :class="[defaultClasses, classes]">
        <div class="self-stretch flex-col justify-start items-start gap-1 flex">
            <div
                class="self-stretch justify-start items-center gap-1 inline-flex gap-2">
                <div
                    class="text-neutral-900 text-base font-bold font-Open-Bold">
                    {{ label }}
                    <span
                        class="text-neutral-500 text-base font-normal font-Open leading-normal ml-2">
                        (optional)
                    </span>
                </div>
            </div>
            <div
                class="self-stretch text-zinc-800 text-sm font-normal font-Open leading-tight max-584 gap-2">
                {{ subtext }}
            </div>
        </div>
        <div class="justify-start items-center gap-6 inline-flex mt-4 mb-4">
            <div
                class="w-24 self-stretch flex-col justify-center ml-[-.5em] items-start gap-2 inline-flex">
                <div class="justify-start items-center gap-2 inline-flex">
                    <label
                        class="relative p-2 flex items-center special-request-yes cursor-pointer">
                        <input
                            type="radio"
                            v-model="selectedValue"
                            value="yes"
                            @change="updateSelectedValue('yes')"
                            class="hidden" />
                        <div class="special-request-radio"></div>
                        <span class="ml-2">Yes</span>
                    </label>
                </div>
            </div>
            <div
                class="w-24 self-stretch flex-col justify-center items-start gap-2 inline-flex">
                <div class="justify-start items-center gap-2 inline-flex">
                    <label
                        class="relative p-2 flex items-center special-request-no cursor-pointer">
                        <input
                            type="radio"
                            v-model="selectedValue"
                            value="no"
                            @change="updateSelectedValue('no')"
                            class="hidden" />
                        <div class="special-request-radio"></div>
                        <span class="ml-2">No</span>
                    </label>
                </div>
            </div>
        </div>
        <div
            class="w-full mb-4"
            v-if="selectedValue === 'yes'">
            <div>
                <label
                    for="additionalInfo"
                    class="block text-neutral-900 text-base font-Open leading-normal mb-2">
                    <span class="font-bold">Notes:</span>
                    <span class="text-[#717171] ml-2">(optional)</span>
                </label>
                <textarea
                    id="additionalInfo"
                    v-model="message"
                    @input="updateMessage"
                    class="w-full p-2 border border-neutral-300 rounded-md text-neutral-900 text-sm font-normal font-Open leading-normal"
                    rows="4"
                    placeholder="Enter special request here"></textarea>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useBookingStore } from '@/stores/booking';
    import { onMounted, ref } from 'vue';
    const props = defineProps({
        label: String,
        subtext: String,
        classes: String,
        type: Number,
    });

    const selectedValue = ref<string | null>(null);
    const { state: bookingState, updateBookingState } = useBookingStore();

    const message = ref(
        bookingState.special_request !== '' ? bookingState.special_request : ''
    );
    const defaultClasses =
        'w-full px-6 pt-4 flex-col flex justify-start items-start inline-flex bg-white special-requests';

    const updateMessage = () => {
        updateBookingState({ special_request: message.value });
    };
    const updateSelectedValue = (value: string) => {
        selectedValue.value = value;
        value === 'no'
            ? updateBookingState({ special_request: '' })
            : updateBookingState({
                  special_request: message.value,
              });
    };

    onMounted(() => {
        selectedValue.value =
            bookingState.special_request !== '' ? 'yes' : 'no';
    });
</script>
